import { ExternalProps } from "../../types.js";

export const getExternalProps = (): ExternalProps | undefined => {
	const el = document
		.querySelector("aurora-mobility-recommendations-podlet-isolated")!
		.shadowRoot!.querySelector("#aurora-mobility-recommendations-podlet-content")!;

	const externalProps = el.getAttribute("externalProps");
	if (!externalProps) {
		return undefined;
	}

	try {
		return JSON.parse(externalProps);
	} catch (e) {
		console.error(e);
		return undefined;
	}
};
